import GetCockpitNotificationsListRequestModelBase from '../_generated/modelBases/get-cockpit-notifications-list-request-model-base';

export default class GetCockpitNotificationsListRequestModel extends GetCockpitNotificationsListRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
